import includes from "lodash/includes";
import map from "lodash/map";
import { ZOOM } from "../constants";
import getGraphNodeSources from "./nodeOrEdgeSourceDataHandling/getGraphNodeSources";
export default (graphComponentRef, nodeId, select) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) || !nodeId)
        return;
    const node = graphComponentRef.current.graph.nodes.find(item => {
        const nodeSourceIds = map(getGraphNodeSources(item), "NodeId");
        return includes(nodeSourceIds, nodeId);
    });
    if (node) {
        if (select) {
            graphComponentRef.current.selection.clear();
            graphComponentRef.current.selection.setSelected(node, true);
        }
        graphComponentRef.current.zoomToAnimated(node.layout.center, select
            ? ZOOM.NAVIGATE_TO_MAX
            : Math.max(Math.min(graphComponentRef.current.zoom, ZOOM.NAVIGATE_TO_MAX), ZOOM.NAVIGATE_TO_MIN));
    }
};
